
import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faChevronLeft, faChevronRight } from '@fortawesome/free-solid-svg-icons';
import ProductCard from '../components/ProductCard/ProductCard';
import './Shop.css';
import {products} from "../data/product_catalog";


const Shop = () => {
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [sortBy, setSortBy] = useState('featured');
  const [priceRange, setPriceRange] = useState('all');
  const [currentPage, setCurrentPage] = useState(1);
  const ITEMS_PER_PAGE = 6;


    // Sample product data - replace with your actual data

    const categories = [
    { id: 'all', name: 'All Products' },
    { id: 'dresses', name: 'Dresses' },
    { id: 'rompers', name: 'Rompers' },
    { id: 'tops', name: 'Tops' },
    { id: 'bottoms', name: 'Bottoms' },
    { id: 'accessories', name: 'Accessories' },
    { id: 'preservation', name: 'Preservation' }
  ];

  const priceRanges = [
    { id: 'all', name: 'All Prices' },
    { id: 'under25', name: 'Under $25' },
    { id: '25-50', name: '$25 - $50' },
    { id: 'over50', name: 'Over $50' }
  ];

  const sortOptions = [
    { id: 'featured', name: 'Featured' },
    { id: 'newest', name: 'Newest' },
    { id: 'price-low', name: 'Price: Low to High' },
    { id: 'price-high', name: 'Price: High to Low' }
  ];

  const filteredProducts = products
      .filter(product => {
        if (selectedCategory === 'all') return true;
        return product.category === selectedCategory;
      })
      .filter(product => {
        switch (priceRange) {
          case 'under25':
            return product.price < 25;
          case '25-50':
            return product.price >= 25 && product.price <= 50;
          case 'over50':
            return product.price > 50;
          default:
            return true;
        }
      })
      .sort((a, b) => {
        switch (sortBy) {
          case 'price-low':
            return a.price - b.price;
          case 'price-high':
            return b.price - a.price;
          case 'newest':
            return new Date(b.dateAdded) - new Date(a.dateAdded);
          default:
            return 0;
        }
      });

  const indexOfLastProduct = currentPage * ITEMS_PER_PAGE;
  const indexOfFirstProduct = indexOfLastProduct - ITEMS_PER_PAGE;
  const currentProducts = filteredProducts.slice(indexOfFirstProduct, indexOfLastProduct);
  const totalPages = Math.ceil(filteredProducts.length / ITEMS_PER_PAGE);

  const handlePageChange = (pageNumber) => {
    setCurrentPage(pageNumber);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  // Reset to first page when filters change
  const handleFilterChange = (filterType, value) => {
    setCurrentPage(1);
    switch (filterType) {
      case 'category':
        setSelectedCategory(value);
        break;
      case 'price':
        setPriceRange(value);
        break;
      case 'sort':
        setSortBy(value);
        break;
      default:
        break;
    }
  };


  const Pagination = () => {
    const getPageNumbers = () => {
      let pages = [];
      const maxVisiblePages = 5;

      if (totalPages <= maxVisiblePages) {
        // Show all pages if total is less than max visible
        for (let i = 1; i <= totalPages; i++) {
          pages.push(i);
        }
      } else {
        // Show pages with ellipsis
        if (currentPage <= 3) {
          for (let i = 1; i <= 4; i++) pages.push(i);
          pages.push('...');
          pages.push(totalPages);
        } else if (currentPage >= totalPages - 2) {
          pages.push(1);
          pages.push('...');
          for (let i = totalPages - 3; i <= totalPages; i++) pages.push(i);
        } else {
          pages.push(1);
          pages.push('...');
          pages.push(currentPage - 1);
          pages.push(currentPage);
          pages.push(currentPage + 1);
          pages.push('...');
          pages.push(totalPages);
        }
      }
      return pages;
    };

    return (
        <div className="pagination">
          <button
              className="pagination-button"
              onClick={() => handlePageChange(currentPage - 1)}
              disabled={currentPage === 1}
              aria-label="Previous Page"
          >
            <FontAwesomeIcon icon={faChevronLeft} />
          </button>

          {getPageNumbers().map((page, index) => (
              <button
                  key={index}
                  className={`pagination-button ${page === currentPage ? 'active' : ''} 
                       ${page === '...' ? 'ellipsis' : ''}`}
                  onClick={() => page !== '...' && handlePageChange(page)}
                  disabled={page === '...'}
              >
                {page}
              </button>
          ))}

          <button
              className="pagination-button"
              onClick={() => handlePageChange(currentPage + 1)}
              disabled={currentPage === totalPages}
              aria-label="Next Page"
          >
            <FontAwesomeIcon icon={faChevronRight} />
          </button>
        </div>
    );
  };


  return (
      <div className="shop-page">
        <div className="shop-header">
          <h1>Shop All</h1>
          <p>{filteredProducts.length} products</p>
        </div>



          <div className="shop-container">
          <aside className="shop-filters">
            <div className="filter-section">
              <h3>Categories</h3>
              <select
                  className="filter-select"
                  value={selectedCategory}
                  onChange={(e) => handleFilterChange('category', e.target.value)}
              >
                {categories.map(category => (
                    <option key={category.id} value={category.id}>{category.name}</option>
                ))}
              </select>
              <div className="filter-options">
                {categories.map(category => (
                    <label key={category.id} className={`filter-option ${selectedCategory === category.id ? 'active' : ''}`}>
                      <input
                          type="radio"
                          name="category"
                          checked={selectedCategory === category.id}
                          onChange={() => handleFilterChange('category', category.id)}
                      />
                      {category.name}
                    </label>
                ))}
              </div>
            </div>

            <div className="filter-section">
              <h3>Price</h3>
              <select
                  className="filter-select"
                  value={priceRange}
                  onChange={(e) => handleFilterChange('price', e.target.value)}
              >
                {priceRanges.map(range => (
                    <option key={range.id} value={range.id}>{range.name}</option>
                ))}
              </select>
              <div className="filter-options">
                {priceRanges.map(range => (
                    <label key={range.id} className={`filter-option ${priceRange === range.id ? 'active' : ''}`}>
                      <input
                          type="radio"
                          name="price"
                          checked={priceRange === range.id}
                          onChange={() => handleFilterChange('price', range.id)}
                      />
                      {range.name}
                    </label>
                ))}
              </div>
            </div>
            <div className="filter-section sorting-filter">
              <h3>Sort By</h3>
              <select
                  className="filter-select"
                  value={sortBy}
                  onChange={(e) => handleFilterChange('sort', e.target.value)}
              >
                {sortOptions.map(option => (
                    <option key={option.id} value={option.id}>{option.name}</option>
                ))}
              </select>
              <div className="filter-options">
                {sortOptions.map(option => (
                    <label key={option.id} className={`filter-option ${sortBy === option.id ? 'active' : ''}`}>
                      <input
                          type="radio"
                          name="sort"
                          checked={sortBy === option.id}
                          onChange={() => handleFilterChange('sort', option.id)}
                      />
                      {option.name}
                    </label>
                ))}
              </div>
            </div>
          </aside>

          <main className="shop-main">
            <div className="shop-controls">
              <select
                  value={sortBy}
                  onChange={(e) => handleFilterChange('sort', e.target.value)}
                  className="sort-select"
              >
                {sortOptions.map(option => (
                    <option key={option.id} value={option.id}>
                      {option.name}
                    </option>
                ))}
              </select>
            </div>

              <div className="products-grid">
                  {currentProducts.map(product => (
                      <ProductCard key={product.id} product={product} />
                  ))}
              </div>

            {totalPages > 1 && (
                <>
                  <Pagination />
                  <div className="pagination-info">
                    Showing {indexOfFirstProduct + 1}-{Math.min(indexOfLastProduct, filteredProducts.length)} of {filteredProducts.length} products
                  </div>
                </>
            )}
          </main>
        </div>
      </div>
  );

};

export default Shop;
